import { FC, useState } from 'react';
import Incident from '../../models/incident.model';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';
import ConfigService from '../../config/config.service';
import Markdown from 'react-markdown'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Clipboard, ClipboardX } from 'react-bootstrap-icons';
import * as icons from 'react-bootstrap-icons';



const config = ConfigService();

interface IncidentsProps {
    incident: Incident
}

const IncidentModalDetails: FC<IncidentsProps> = ({ incident }) => {
    const { t, i18n } = useTranslation();
    let [copyStatus, setCopyStatus] = useState(false);

    const isNotImage = (fileName: string) => {
        if (fileName.indexOf(".doc") !== -1 || fileName.indexOf(".xls") !== -1
            || fileName.indexOf(".docx") !== -1 || fileName.indexOf(".xlsx") !== -1
            || fileName.indexOf(".ppt") !== -1 || fileName.indexOf(".pptx") !== -1
            || fileName.indexOf(".pdf") !== -1 || fileName.indexOf(".csv") !== -1
            || fileName.indexOf(".odp") !== -1 || fileName.indexOf(".ods") !== -1
            || fileName.indexOf(".odt") !== -1) {
            return true;
        }
        return false;
    }

    return (
        <Container fluid color={'#000'} style={{ backgroundColor: '#000', color: '#fff', textDecorationColor: '#fff' }}>

            <Row>
                <Col md={11} style={{ color: '#ECECEC' }}><b>{incident.title}</b></Col>
            </Row>
            <Row>
                <Col md={11}><br /></Col>
            </Row>
            <Row>
                <Col md={11} style={{ color: '#CBCBCE' }}>
                    <Markdown>{incident.getDescription(i18n.language)}</Markdown>
                </Col>
            </Row>

            <Row>
                <Col md={11}><br /></Col>
            </Row>
            <Row>
                <Col md={11}>
                    {
                        incident.fileName && incident.fileName.map((f: any, index: any) => {
                            if (isNotImage(f)) {
                                return <><a key={`a${f}${index}`} href={`img/${f}`}>{incident.originalFileName[index]}</a><br /></>
                            }
                        })
                    }
                </Col>
            </Row>

        </Container>
    );
};

export default IncidentModalDetails;